<template>
  <header class="header-content">
    <div class="flex items-center justify-between header-bg" style="width: 100%;padding: 0 80px;height: 80px;background: rgba(7, 21, 108, 0.7)">
      <div class="flex items-center">
        <div class="logo-container">
          <p class="logo-view flex items-center justify-center" @click="goHome">
            <img :src="require('@/assets/images/logo_copy2.png')" alt="" />
          </p>
        </div>
        <el-menu
          :default-active="activeRoute"
          background-color="transparent"
          mode="horizontal"
          class="flex el-menu-horizontal"
          style="padding-left: 60px"
        >
          <div v-for="menu in menuList" :key="menu.name">
            <div v-if="menu.name !== 'agent' && menu.name !== 'writingAssistant'">
              <el-menu-item
                @click="clickMenuList(menu)"
                v-if="!menu.children"
                :index="menu.name"
              >
                <span slot="title">{{ menu.label }}</span>
              </el-menu-item>

              <el-submenu :index="menu.name" popper-class="submenu-popper" v-else>
                <template slot="title">
                  <!-- <i :class="'el-icon-' + menu.icon"></i>-->
                  <span slot="title">{{ menu.label }}</span>
                </template>
                <div v-for="subItem in menu.children" :key="subItem.name">
                  <el-menu-item @click="clickMenuList(subItem)" :index="subItem.name">
                    <!-- <i :class="'el-icon-' + subItem.icon"></i>-->
                    <span slot="title">{{ subItem.label }}</span>
                  </el-menu-item>
                </div>
              </el-submenu>
            </div>
            <div class="custom-menu-item" @click="clickMenuList(menu)" v-else-if="menu.name === 'agent' || menu.name === 'writingAssistant'">
              {{ menu.label }}
            </div>
          </div>
        </el-menu>
      </div>
      <div class="flex items-center fileManage-userName">
        <div class="file-manage" @click="$router.push({name: 'fileManagement'})" v-if="isShowFileManagement">
          <el-badge :is-dot="isRead" class="badge-dot">
            <div class="flex items-center" style="vertical-align: bottom">
              <i class="el-icon-folder"></i>
              <span class="no-wrap">文件管理</span>
            </div>
          </el-badge>
        </div>

        <el-avatar size="small" :src="circleUrl"></el-avatar>

        <el-dropdown @command="clickMenu" trigger="hover">
          <span class="user-name no-wrap">{{ userName || 'admin' }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in menu"
              :key="item.path"
              :command="item"
            >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="notification-banner">
      <div class="notification-content">
        <i class="el-icon-warning-outline notification-icon"></i>
        <span class="notification-text">
          本系统已迁至新地址
          <a href="javascript:void(0)" @click="goToNewSystem" class="notification-link">https://ai.zhitulist.com/achievement-ai-assistant</a>
          ，功能完全一致。当前地址不再更新，将于 2026年11月13日 关闭下线，请尽快迁移。如有问题请联系 15033960786（微信）。
        </span>
      </div>
    </div>
  </header>
</template>

<script>
import { isReadApi } from '@/api/fileManagement';
import { permissionDetailApi } from '@/api/login';

const invalidUserNameValues = ['null', 'undefined', 'nan'];

export default {
  name: 'CommonHeader',
  data() {
    return {
      circleUrl:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',

      userName: '', // 用户名
      isShowFileManagement: false, // 文件管理 入口
      // 用户菜单
      menu: [
        {
          path: '/login',
          name: 'Login',
          label: '退出登录',
        },
      ],
      menuList: [],

      /*menuList: [
        {
          path: '/resultsAnalysis',
          name: 'resultsAnalysis',
          label: '成果分析',
        },
        {
          path: '/requirementAnalysis',
          name: 'requirementAnalysis',
          label: '需求分析',
        },
        {
          path: '/scholarSearch',
          name: 'scholarSearch',
          label: '专家查询',
        },
        {
          path: '/technicalQA',
          name: 'technicalQA',
          label: '技术问答',
        },
        {
          path: '/agent',
          name: 'agent',
          label: '智能体',
        },
        {
          path: '/writingAssistant',
          name: 'writingAssistant',
          label: '智能写作',
        },
        {
          path: '/historicRecords',
          name: 'historicRecords',
          label: '历史记录',
        },
        /!*{
          path: '/researchToolkit',
          name: 'researchToolkit',
          label: '科研工具',
          children: [
            {
              path: '/researchToolkit/abstract',
              name: 'abstract',
              label: '生成摘要',
            },
            {
              path: '/researchToolkit/chinese',
              name: 'chinese',
              label: '中文润色',
            },
          ],
        },*!/
      ],*/

      activeRoute: '',
      isRead: false,
    };
  },
  created() {
    this.userName = this.getUserName();
    this.activeRoute = this.$route.query.active || this.$route.name;

    this.getIsRead();

    if (this.$route.name === 'resultsDetails') {
      this.activeRoute = 'resultsAnalysis';
    }
    if (this.$route.name === 'requirementDetails') {
      this.activeRoute = 'requirementAnalysis';
    }
    if (this.$route.name === 'scholarSearchHistory') {
      this.activeRoute = 'scholarSearch';
    }
    if (this.$route.name === 'technicalQAHistory') {
      this.activeRoute = 'technicalQA';
    }
  },
  methods: {
    normalizeUserName(value) {
      if (value === null || value === undefined) {
        return '';
      }
      if (typeof value !== 'string' && typeof value !== 'number') {
        return '';
      }

      const userName = String(value).trim();
      return userName && !invalidUserNameValues.includes(userName.toLowerCase()) ? userName : '';
    },
    getUserName() {
      return this.normalizeUserName(this.$store.state.nickName) || this.normalizeUserName(localStorage.getItem('at_nickName'));
    },
    goHome() {
      this.$router.push({ name: 'resultsAnalysis' })
    },
    goToNewSystem() {
      // 清除本地存储的 token 和用户信息
      localStorage.removeItem('at_token');
      localStorage.removeItem('at_userId');
      localStorage.removeItem('at_userName');
      localStorage.removeItem('at_nickName');
      localStorage.removeItem('at_tags');
      // 清除 vuex 状态
      this.$store.commit('logout');
      // 在当前页面跳转到新系统
      window.location.href = 'https://ai.zhitulist.com/achievement-ai-assistant';
    },
    clickMenuList(item) {
      if (item.label === '智能体') {
        window.open('http://124.207.169.15:8905/hang-agent/', '_blank');
      }
      else if (item.label === '智能写作') {
        window.open('http://124.207.169.15:8905/writing-assistant/', '_blank');
      }
      else {
        this.$router.push({
          name: item.name,
        });
      }
    },
    clickMenu(item) {
      if (item.name === 'Login') {
        this.$message({
          message: '成功退出登录',
          type: 'success',
        });
        this.$store.commit('logout');
        this.$router.push({ name: 'login' });
      }
    },
    getIsRead() {
      isReadApi().then((res) => {
        this.isRead = res.data;
      })
    },
    // 获取访问权限
    getRolesData() {
      let userId = localStorage.getItem('at_userId');
      permissionDetailApi({ userId }).then((res) => {
        if (res.code === 200) {
          if (res.data.system === 'achievement-assistant') {
            // quota
            let quotaList = res.data.permissionApiQuotaVO.apiQuotaList;
            this.$store.commit('SET_Quota', quotaList);
            // tags
            if (res.data.permissionTagVO.tags && res.data.permissionTagVO.tags?.length) {
              let Tags = res.data.permissionTagVO.tags;
              let userNav = Tags.filter(tag => tag.label !== '文件管理' && tag.authorization == 1);
              this.$store.commit('SET_Tags', Tags);
              this.menuList = userNav;
              this.activeRoute = this.$route.name || userNav[0].name;
              this.isShowFileManagement = Tags.some( tag => tag.label === '文件管理' && tag.authorization == 1);
            } else {
              this.$message.warning('该账号暂无使用权限，请联系管理员');
              setTimeout(()=>{
                this.$store.commit('logout');
                this.$router.push({ name: 'login' });
              },300)
            }
          } else {
            this.$message.warning('该账号暂无使用权限，请联系管理员');
            setTimeout(()=>{
              this.$store.commit('logout');
              this.$router.push({ name: 'login' });
            },300);
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },
  },
  watch: {
    $route: {
      handler(to) {
        let tags = JSON.parse(localStorage.getItem('at_tags'))
        this.menuList = tags?.length ? tags.filter(tag => tag.label !== '文件管理' && tag.authorization == 1 ) : [];
        this.getRolesData();
        this.getIsRead();
        this.userName = this.getUserName();
        this.activeRoute = to.query.active || to.name;

        if (to.name === 'resultsDetails') {
          this.activeRoute = 'resultsAnalysis';
        }
        if (to.name === 'requirementDetails') {
          this.activeRoute = 'requirementAnalysis';
        }
        if (to.name === 'scholarSearchHistory') {
          this.activeRoute = 'scholarSearch';
        }
        if (to.name === 'technicalQAHistory') {
          this.activeRoute = 'technicalQA';
        }
      },
      deep: true,
      immediate: true,
    }
  },
};
</script>

<style scoped lang="less">
.header-content {
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-image: url("~@/assets/images/bg.png");
  background-size: 100% auto;
  background-position: 0 0;
  background-repeat: no-repeat;

  .notification-banner {
    width: 100%;
    background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
    border-bottom: 1px solid #ffc107;
    padding: 10px 20px;
    box-sizing: border-box;

    .notification-content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: 0 auto;
    }

    .notification-icon {
      color: #e6a23c;
      font-size: 18px;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .notification-text {
      color: #856404;
      font-size: 14px;
      line-height: 1.6;
      text-align: center;
    }

    .notification-link {
      color: #409eff;
      text-decoration: underline;
      font-weight: 500;

      &:hover {
        color: #66b1ff;
      }
    }
  }

  .logo-container {
    display: flex;
    align-items: center;

    .logo-view {
      flex-shrink: 0;
      width: 300px;
      height: 40px;
      user-select: none;
      img {
        flex-shrink: 0;
        width: 293px;
        height: 33px;
        vertical-align: center;
      }
    }

    span {
      padding-left: 10px;
      font-weight: bold;
      font-size: 23px;
      color: #333;
      //font-style: italic;
    }
  }


  .el-menu {
    //height: 100%;
    border: none;
    text-align: left;

    /deep/ .el-menu-item,
    /deep/ .el-submenu__title {
      background-color: transparent !important;
      display: inline-block;
      font-size: 18px !important;
      text-align: left !important;
      margin: 0;
      color: #c1c1c1;
      padding: 0 20px;
      border-radius: 6px !important;
      height: auto !important;
      line-height: 40px !important;
      //padding-left: 12px !important;
      letter-spacing: 0.5px;

      span {
        font-size: 18px !important;
      }
    }

    /deep/ .el-menu-item.is-active {
      //background-color: #0a74e0 !important;
      font-weight: 700 !important;
      color: #ffffff;
    }

    /deep/ .el-submenu {
      margin: 0 auto;
      .el-menu-item {
        padding-left: 20px !important;
      }
      ///deep/ .el-submenu__title {
      //  width: 100% !important;
      //}
      .el-submenu__icon-arrow {
        right: 0;
        font-size: 15px;
        font-weight: bold;
        color: #666666;
      }
    }
    /deep/.el-submenu.is-active {
      .el-submenu__title {
        color: #ffffff;
      }
      .el-submenu__icon-arrow {
        color: #ffffff;
      }
    }

    /deep/ .el-icon-star-on {
      font-size: 22px !important;
    }
  }

  .el-menu-horizontal {
    &:not(.el-menu--collapse) {
      //width: 200px;
    }

    /deep/ .el-menu-item {
      user-select: none !important;
    }

    /deep/ .el-submenu__icon-arrow.el-icon-arrow-right:before {
      content: '' !important;
    }
  }

  // 自定义外部链接菜单项样式
  .custom-menu-item {
    display: inline-block;
    font-size: 18px !important;
    text-align: left !important;
    color: #c1c1c1;
    padding: 0 20px;
    border-radius: 6px !important;
    height: auto !important;
    line-height: 40px !important;
    letter-spacing: 0.5px;
    cursor: pointer;
    margin-top: 2px;
    user-select: none;
    white-space: nowrap;
  }
}

.fileManage-userName {
  margin-bottom: -3px;
  height: 24px;
  line-height: 24px;
}


.file-manage {
  color: #FFFFFF;
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-right: 20px;
  cursor: pointer;

  i{
    font-size: 18px;
    margin-right: 5px;
  }

  /deep/ .el-badge {
    .el-badge__content {
      border: none !important;
    }
    .el-badge__content.is-fixed.is-dot {
      right: 3px !important;
    }
  }
}

.user-name {
  display: inline-block;
  line-height: 40px;
  font-size: 16px;
  margin-left: 10px;
  cursor: pointer;
  color: #fff;
  vertical-align: bottom;
}
</style>
<style lang="less">
.submenu-popper {
  .el-menu {
    .el-menu-item.is-active {
      color: #48adca;
      font-weight: bold;
    }
  }
}
</style>
